<template>
  <div class="form-wrapper">
    <h4>{{ title }}</h4>

    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="stylus" scoped>
.form-wrapper {
  width 350px
  background rgba(27, 74, 108, 0.8)
  position relative
  border-bottom-left-radius 60px
  border-bottom-right-radius 60px
  border-bottom 6px solid #0a3353
  border-top-right-radius 50px
  perspective 1000px

  h4 {
    text-align center
    padding 20px
    color #0a3353
    font-weight 500
  }

  &:before {
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100px
    background #f8f8f8
    border-bottom-right-radius 100%
    border-bottom-left-radius 100%
    border-top-right-radius 100px
    z-index -1
  }

  .content {
    padding 20px
  }
}
</style>
